module.exports = __webpack_public_path__ + "img/CHINAUMS2.ddceb1d9.png";